import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { HeartIcon, CrashIcon, FuelIcon, RpmIcon } from '../../../../../common/icons';

import './NoticeDetailType.css';

@inject('translationsStore')
@observer
export default class NoticeDetailType extends Component {
  render() {
    const { translationsStore, type, geofenceOptions } = this.props;

    return (
      <div className="NoticeDetailType">
        {(() => {
          switch (type) {
            case 'crash':
              return (
                <div style={{ color: 'var(--red-dtc-color)', marginRight: 10 }}>
                  <CrashIcon />
                </div>
              );
            // case 'heartbeat': return <HeartIcon />;
            // case 'unplugged': return <HeartIcon />;
            // case 'blockbeat': return <HeartIcon />;
            // case 'COA': return <HeartIcon />;
            case 'fuel-theft':
              return (
                <div style={{ color: 'var(--red-dtc-color)', marginRight: 10 }}>
                  <FuelIcon width="18px" height="20px" />
                </div>
              );
            case 'rpm-over':
              return (
                <div style={{ color: 'var(--red-dtc-color)', marginRight: 10 }}>
                  <RpmIcon width="18px" height="20px" />
                </div>
              );
            case 'geofenceInside':
              return (
                <div>
                </div>
              );
            case 'geofenceOutside':
              return (
                <div>
                </div>
              );
            default:
              return (
                <div style={{ color: 'var(--red-dtc-color)', marginRight: 10 }}>
                  <HeartIcon />
                </div>
              );
          }
        })()}
        <div>{
          type
            ? translationsStore.translate(`notices.types.${type}`)
            : ''
        }
        {(() => {
          switch (type) {
            case 'geofenceInside':
              if (geofenceOptions && geofenceOptions.name) {
                return ' ' + geofenceOptions.name;
              }
              break;
            case 'geofenceOutside':
              if (geofenceOptions && geofenceOptions.name) {
                return ' ' + geofenceOptions.name;
              }
              break;
            default:
              return '';
          }
        })()}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/NoticesLoader/NoticeDetail/NoticeDetailType/NoticeDetailType.js